<template>
  <div>
    <search-esim-supplier @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          type="primary"
          @click="showNewModal"
          v-if="isShowMenu('esim_suppliers/new')"
        >新增</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
    >
      <div slot="name" slot-scope="name, record">
        <div v-if="isShowMenu('esim_suppliers/show')">
          <router-link :to="{ name: 'esim_supplier_info', params: { id: record.id }}">{{ name }}</router-link>
        </div>
        <div v-else>{{ name }}</div>
      </div>

      <span slot="actions" slot-scope="text, record">
        <a-space>
          <a @click="showEditModal(record.id)" v-if="isHasEditPermission">编辑</a>
        </a-space>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <new-esim-supplier
      v-if="isShowNewModal"
      :visible.sync="isShowNewModal"
      @completed="fetchData"
    />

    <edit-esim-supplier
      v-if="isShowEditModal"
      :visible.sync="isShowEditModal"
      :id="editingId"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findEsimSuppliers } from '@/api/esim_supplier'
import Pagination from '@/components/Pagination'
import SearchEsimSupplier from '@/views/esim_suppliers/Search'

export default {
  name: 'EsimSupplierList',
  components: {
    Pagination,
    SearchEsimSupplier,
    NewEsimSupplier: () => import('@/views/esim_suppliers/New'),
    EditEsimSupplier: () => import('@/views/esim_suppliers/Edit')
  },
  data() {
    return {
      data: [],
      columns: [
        {
          title: '名称',
          dataIndex: 'name',
          width: 180,
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '联系人',
          dataIndex: 'contact_name',
          width: 120
        },
        {
          title: '联系人电话',
          dataIndex: 'contact_phone',
          width: 140
        },
        {
          title: 'eSIM总量',
          dataIndex: 'esim_total_count',
          width: 110
        },
        {
          title: '库存量',
          dataIndex: 'esim_stock_count',
          width: 110
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          width: 200
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          width: 170
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' }
        }
      ],
      loading: true,
      isShowNewModal: false,
      isShowEditModal: false,
      editingId: 0,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  computed: {
    isHasEditPermission() {
      return hasPermission('esim_suppliers/edit')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    showNewModal() {
      this.isShowNewModal = true
    },

    showEditModal(id) {
      this.editingId = id
      this.isShowEditModal = true
    },

    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findEsimSuppliers(Object.assign({}, this.query)).then((res) => {
        this.data = res.data
        this.pagination = res.pagination
        this.loading = false
      })
    }
  }
}
</script>
